import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import PremiumIcon from '../../assets/images/icons/PremiumIcon.svg';
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import { isAdmin } from '../../helpers/helpers_general.js';
import { deleteContent } from '../../services/contents.js';
import BookInformation from './book_information.js';
import NewContentModal from '../modals/NewContentModal.js';
import DeleteConfirmModal from '../modals/DeleteConfirmModal.js';
import { useAlert } from '../../context/index.js';
import { AlertSuccess } from '../Alerts/index.js';

import './content-row.scss';

const EXT_COLORS = {
  PDF: '#e53935',
  DOC: '#1565c0',
  DOCX: '#1565c0',
  XLS: '#2e7d32',
  XLSX: '#2e7d32',
  PPT: '#e65100',
  PPTX: '#e65100',
  ZIP: '#6d4c41',
  RAR: '#6d4c41',
  MP4: '#6a1b9a',
  MP3: '#00838f',
};

const extColor = ext => EXT_COLORS[ext] || '#546e7a';

const formatDate = dateStr => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
    ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

const ContentRow = props => {
  const { contentId, categoryId, categorySlug, showCategoryBadge, title, description, premium, document_count, extensions, updated_at } = props;

  const [states, setStates] = useState({ showModal: false, showNewContentModal: false, showContentModal: false });
  const { setShowError, setShowSuccess, setTextSuccessAlert, setTextErrorAlert, textSuccessAlert } = useAlert();

  const deleteCard = () => {
    deleteContent(contentId).then(
      () => {
        setShowSuccess(true);
        setTextSuccessAlert('Arquivo deletado com sucesso!');
        setStates(prev => ({ ...prev, showModal: false }));
        setTimeout(() => window.location.reload(), 1500);
      },
      () => {
        setShowError(true);
        setTextErrorAlert('Um erro ocorreu ao deletar o arquivo.');
        setStates(prev => ({ ...prev, showModal: false }));
      }
    );
  };

  return (
    <Box className="content-row">
      <Box className="content-row-main" onClick={() => setStates(prev => ({ ...prev, showContentModal: true }))}>
        <Box className="content-row-info">

          {/* Linha do título com botão editar no canto direito */}
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '8px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', flex: 1 }}>
              <Typography className="content-row-title">{title}</Typography>
              {premium && <img src={PremiumIcon} alt="premium" style={{ width: '16px' }} />}
            </Box>
            {isAdmin() && (
              <IconButton
                size="small"
                sx={{ flexShrink: 0, padding: '2px' }}
                onClick={e => { e.stopPropagation(); setStates(prev => ({ ...prev, showNewContentModal: true })); }}
              >
                <img src={EditIcon} alt="Editar" style={{ width: '16px', opacity: 0.5 }} />
              </IconButton>
            )}
          </Box>

          {showCategoryBadge && categorySlug && (
            <Box sx={{ display: 'inline-block', mt: '4px', mb: '2px' }}>
              <Box component="span" sx={{
                fontSize: '11px', fontWeight: 600, color: '#006494',
                backgroundColor: '#e8f4fb', borderRadius: '4px',
                padding: '2px 8px', textTransform: 'capitalize',
              }}>
                {categorySlug}
              </Box>
            </Box>
          )}
          <Typography className="content-row-description">{description}</Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px', flexWrap: 'wrap' }}>
            <Typography className="content-row-meta">
              {document_count ?? 0} {(document_count ?? 0) === 1 ? 'arquivo' : 'arquivos'}
            </Typography>
            {(extensions || []).map(ext => (
              <Box key={ext} className="content-row-ext-badge" style={{ backgroundColor: extColor(ext) }}>
                {ext}
              </Box>
            ))}
            {updated_at && (
              <Typography className="content-row-date">
                {formatDate(updated_at)}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>

      <DeleteConfirmModal showModal={states.showModal} setStates={setStates} deleteCard={deleteCard} title={title} />
      <NewContentModal
        title="Editar Conteúdo"
        card={props}
        categoryId={categoryId}
        showNewContentModal={states.showNewContentModal}
        setStates={setStates}
        onDelete={() => setStates(prev => ({ ...prev, showNewContentModal: false, showModal: true }))}
      />
      <BookInformation showContentModal={states.showContentModal} setModalStates={setStates} contentId={contentId} title={title} description={description} />
      <AlertSuccess textAlert={textSuccessAlert} />
    </Box>
  );
};

export default ContentRow;
